import { register } from "./Registry"

register('hamburger', () => {
	const header = document.querySelector('header')
	const hamburger = header?.querySelector('div.hamburger')
	const overlay = header?.querySelector('div.overlay')

	hamburger?.addEventListener('click', () => {
		header?.classList.toggle('open')
	})

	overlay?.addEventListener('click', () => {
		header?.classList.remove('open')
	})
})
